var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 69.358 42.474 c -1.687 -1.423 -4.211 -1.209 -5.636 0.479 L 49 60.412 V 4 c 0 -2.209 -1.791 -4 -4 -4 s -4 1.791 -4 4 v 56.412 L 26.277 42.953 c -1.425 -1.69 -3.948 -1.903 -5.637 -0.479 c -1.689 1.424 -1.903 3.948 -0.479 5.637 l 21.781 25.829 c 0.033 0.039 0.075 0.067 0.11 0.104 c 0.114 0.125 0.237 0.238 0.366 0.348 c 0.082 0.07 0.16 0.141 0.247 0.204 c 0.145 0.105 0.3 0.192 0.459 0.277 c 0.083 0.044 0.161 0.096 0.248 0.134 c 0.186 0.083 0.382 0.143 0.581 0.197 c 0.07 0.019 0.135 0.049 0.206 0.064 C 44.43 75.326 44.711 75.36 45 75.36 s 0.57 -0.034 0.842 -0.093 c 0.071 -0.015 0.136 -0.045 0.205 -0.064 c 0.199 -0.054 0.396 -0.114 0.581 -0.197 c 0.086 -0.038 0.164 -0.09 0.247 -0.134 c 0.159 -0.085 0.314 -0.172 0.459 -0.277 c 0.087 -0.063 0.165 -0.134 0.247 -0.204 c 0.129 -0.11 0.252 -0.223 0.366 -0.348 c 0.034 -0.038 0.077 -0.065 0.11 -0.104 l 21.78 -25.829 C 71.263 46.422 71.048 43.898 69.358 42.474 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 76.558 90 H 13.443 c -2.209 0 -4 -1.791 -4 -4 s 1.791 -4 4 -4 h 63.115 c 2.209 0 4 1.791 4 4 S 78.767 90 76.558 90 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/download_icon.800f0027c9772e1d890bac438d4407bb.svg";
export { ForwardRef as ReactComponent };